import { useEffect } from 'react';
import { Sparkles } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useAskAiStore } from '@/store/askAiStore';

function isTypingTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  const tag = target.tagName;
  if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return true;
  if (target.isContentEditable) return true;
  return false;
}

export function AskAiTrigger() {
  const isOpen = useAskAiStore((s) => s.isOpen);
  const toggle = useAskAiStore((s) => s.toggle);

  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      const isMac = navigator.platform.toUpperCase().includes('MAC');
      const modifier = isMac ? e.metaKey : e.ctrlKey;
      if (!modifier) return;
      if (e.key.toLowerCase() !== 'k') return;
      if (isTypingTarget(e.target)) return;
      e.preventDefault();
      toggle();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [toggle]);

  return (
    <button
      type="button"
      aria-label="Ask AI"
      onClick={toggle}
      className={cn(
        'fixed bottom-6 right-6 z-40 inline-flex items-center gap-2 rounded-full',
        'bg-primary px-4 py-3 text-sm font-medium text-primary-foreground shadow-lg',
        'transition-all hover:bg-primary/90 hover:shadow-xl',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
        isOpen && 'opacity-0 pointer-events-none',
      )}
    >
      <Sparkles className="h-4 w-4" />
      Ask AI
    </button>
  );
}

export default AskAiTrigger;
